/*
https://github.com/themesberg/flowbite-icons
Flowbite Icons is free and open-source under the MIT License.
*/
import React from 'react';

interface Props {
    readonly className?: string;
}

export default function WandMagicSparkles({
    className = null,
}: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <g clipPath="url(#clip0_141_41560)">
                <path d="M22.282 8.76384L0.908 29.7813C0.126 30.5503 0.126 31.7932 0.908 32.5622L6.564 38.1238C6.954 38.5073 7.466 38.7001 7.978 38.7001C8.49 38.7001 9.002 38.5073 9.392 38.1238L30.766 17.1063L22.282 8.76384Z" fill="currentColor" />
                <path d="M39.092 8.91921C39.874 8.15025 39.874 6.90733 39.092 6.13838L33.436 0.576717C32.654 -0.192239 31.39 -0.192239 30.608 0.576717L25.11 5.98301L33.594 14.3255L39.092 8.91921Z" fill="currentColor" />
                <path d="M32 32.1334H30V30.1668C30 29.0792 29.106 28.2002 28 28.2002C26.894 28.2002 26 29.0792 26 30.1668V32.1334H24C22.894 32.1334 22 33.0125 22 34.1001C22 35.1876 22.894 36.0667 24 36.0667H26V38.0334C26 39.1209 26.894 40 28 40C29.106 40 30 39.1209 30 38.0334V36.0667H32C33.106 36.0667 34 35.1876 34 34.1001C34 33.0125 33.106 32.1334 32 32.1334Z" fill="currentColor" />
                <path d="M2 16.4003H4V18.367C4 19.4545 4.894 20.3336 6 20.3336C7.106 20.3336 8 19.4545 8 18.367V16.4003H10C11.106 16.4003 12 15.5212 12 14.4337C12 13.3461 11.106 12.467 10 12.467H8V10.5004C8 9.41284 7.106 8.53375 6 8.53375C4.894 8.53375 4 9.41284 4 10.5004V12.467H2C0.894 12.467 0 13.3461 0 14.4337C0 15.5212 0.894 16.4003 2 16.4003Z" fill="currentColor" />
                <path d="M34 22.3002H30V26.2335H34V22.3002Z" fill="currentColor" />
                <path d="M22 0.667183H18V4.60046H22V0.667183Z" fill="currentColor" />
                <path d="M16 4.60046H12V8.53375H16V4.60046Z" fill="currentColor" />
                <path d="M10 0.667183H6V4.60046H10V0.667183Z" fill="currentColor" />
                <path d="M40 16.4003H36V20.3336H40V16.4003Z" fill="currentColor" />
                <path d="M40 26.2335H36V30.1668H40V26.2335Z" fill="currentColor" />
            </g>
            <defs>
                <clipPath id="clip0_141_41560">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
